import {Text} from '@forecast-it/design-system';
import React from 'react';
import {TimeRegistrationSettings} from '../../../util/cache/TimeRegistrationSettingsUtil';
import {useTimeRegistrationSettings} from '@/forecast-app/shared/hooks/useTimeRegistrationSettings';

const prefix = 'You can not register time ';
const allowExceedingEstimate = "exceeding a task's estimate";
const allowOutsideTaskDates = "outside a task's dates";
const allowOutsideProjectDates = "outside a project's dates";
const allowOutsideTaskOrProjectDates = "outside a task or project's dates";
const requireNote = 'without adding a note';

type MessageSettings = Pick<
	TimeRegistrationSettings,
	'allowExceedingEstimate' | 'allowOutsideTaskDates' | 'allowOutsideProjectDates' | 'requireNote'
>;

function getMessageComponents(settings: MessageSettings) {
	const messageComponents: string[] = [];
	if (!settings.allowExceedingEstimate) {
		messageComponents.push(allowExceedingEstimate);
	}

	if (!settings.allowOutsideTaskDates && !settings.allowOutsideProjectDates) {
		messageComponents.push(allowOutsideTaskOrProjectDates);
	} else if (!settings.allowOutsideTaskDates) {
		messageComponents.push(allowOutsideTaskDates);
	} else if (!settings.allowOutsideProjectDates) {
		messageComponents.push(allowOutsideProjectDates);
	}
	if (settings.requireNote) {
		messageComponents.push(requireNote);
	}
	return messageComponents;
}

function formatMessage(messageComponents: string[]): string | undefined {
	if (messageComponents.length === 0) {
		return undefined;
	} else if (messageComponents.length === 1) {
		return prefix + messageComponents[0];
	} else {
		let finalMessage = prefix;
		const firstComponents = messageComponents.slice(0, -2);
		const lastTwoComponents = messageComponents.slice(-2);
		if (firstComponents.length > 0) {
			finalMessage += firstComponents.join(', ') + ', ';
		}
		finalMessage += lastTwoComponents.join(' or ');
		return finalMessage;
	}
}

export function TimeRegistrationSettingsInfoMessage(): JSX.Element | null {
	const timeRegSettings = useTimeRegistrationSettings();
	const messageComponents = getMessageComponents(timeRegSettings);
	const infoText = formatMessage(messageComponents);

	if (infoText === undefined) return null;

	return (
		<>
			<Text size={'2'}>{infoText}</Text>
			<Text size={'2'} color={'medium'}>
				This is a company-wide setting configured by your admin.
			</Text>
		</>
	);
}
